export default __webpack_public_path__ + "static/media/HK.e4f8db83.svg";